// **** This SCROLL TO TOP is different ****
// This correct the issue when clicking in a button and not being
// reedirected to the beginning of the component, instead it will send you to the middle
//
// The solution is to wrap the App components inside the scroll.

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ReactScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
